import { Select } from '@/lib/Selects';
import i18n from '@/localization';
import { ISelectItem } from '@/models/select';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { LOCALIZATION_OPTIONS, LocalizationTitle } from '../../workspaceEdit/components/LocalizationSelector/constants';
import { localeToOption, setLocale } from '../../workspaceEdit/components/LocalizationSelector/helpers';

export const LocalizationSelector: FC = () => {
  const { t } = useTranslation();

  const value = useMemo(() => {
    const temp = localeToOption(i18n.language);

    return {
      ...temp,
      label:
        t(`localization:${temp.label as LocalizationTitle}`)
          .charAt(0)
          .toUpperCase() + t(`localization:${temp.label as LocalizationTitle}`).slice(1),
    };
  }, [i18n.language]);

  const handleChange = (value: ISelectItem) => {
    setLocale(value.id as string);
  };

  const options = LOCALIZATION_OPTIONS.map((option) => ({
    ...option,
    label:
      t(`localization:${option.label as LocalizationTitle}`)
        .charAt(0)
        .toUpperCase() + t(`localization:${option.label as LocalizationTitle}`).slice(1),
  }));

  return (
    <div className='flex flex-col gap-2'>
      <label className='text-sm font-normal text-secondary-700'>{t('settings:language')}</label>
      <Select value={value} items={options} onChange={handleChange} classNames={{ footer: { wrapper: 'hidden' } }} />
    </div>
  );
};
